import { render, staticRenderFns } from "./EzUserRemoveConfirmation.vue?vue&type=template&id=a1f46096&"
import script from "./EzUserRemoveConfirmation.vue?vue&type=script&lang=js&"
export * from "./EzUserRemoveConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports